import React from 'react';
import { Trans } from 'react-i18next';

import { Flex, Text } from '@chakra-ui/react';

import { Alert } from '~/components/alert-v2';
import { ButtonLink } from '~/components/button-link';
import { Modal } from '~/components/modal';
import { useI18n } from '~/hooks/use-i18n';

interface SubscriptionPausedModalProps {
  isOpen: boolean;
  paymentDate?: string | null;
  onClose: () => void;
}

export function SubscriptionPausedModal(props: SubscriptionPausedModalProps) {
  const { t } = useI18n();

  const { isOpen, paymentDate, onClose } = props;

  return (
    <Modal
      isOpen={isOpen}
      size='xl'
      title={t('settings.subscription.isPaused')}
      footerButtons={
        <ButtonLink buttonProps={{ size: 'sm' }} linkProps={{ href: '/settings/subscription' }}>
          {t('settings.manageSubscription')}
        </ButtonLink>
      }
      onClose={onClose}
    >
      <Flex direction='column' gap={4}>
        <Text>{t('settings.subscription.pauseBlockedContent1')}</Text>
        <Text>{t('settings.subscription.pauseBlockedContent2')}</Text>
        <Alert status='info'>
          <Text color='grey.700' fontSize='sm'>
            <Trans
              i18nKey='settings.subscription.resumeSubscriptionDate'
              transSupportBasicHtmlNodes={true}
              values={{
                resumeDate: paymentDate,
              }}
            />
          </Text>
        </Alert>
      </Flex>
    </Modal>
  );
}
